// ** React Imports
import { lazy } from 'react';

const AnalyticsRoutes = [
  {
    path: 'analytics',
    component: lazy(() => import('views/analytics')),
  },
];

export default AnalyticsRoutes;
